import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import Styles from '../../../styles/pages/boys-fashion/common.module.css';
import { Product } from '../../../interfaces/common/girls_fashion';
import { useDispatch } from 'react-redux';
import { addToCart } from '../../../data-access/apis/common/Carts';
import { AppDispatch } from '../../../store';
import { boysFashionAge2to6 } from '../../../data-access/product-data/section-one/BoysFashionAge2to6';

const BoysFashionAge2to6 = () => {

    // Dispatch the addToCart action with the payload (product without id)
    const dispatch = useDispatch<AppDispatch>(); // ✅ strongly typed dispatch

    // ✅ Function to handle Add to Cart
    const handleAddToCart = (product: Product) => {
        // Remove 'id' from product before adding to cart
        const { id, ...payload } = product;

        console.log("Product added to cart:", payload);

        dispatch(addToCart(payload));  // Dispatch the action
    };
    return (
        <>
            <Container>
                <Row className="g-3">
                    {boysFashionAge2to6.map((item) => (
                        <Col key={item.id} xs={12} sm={6} md={4} lg={3}>
                            <Card className={`h-100 shadow-sm ${Styles.cardBase} ${Styles.cardHover}`}>
                                <Card.Img
                                    variant="top"
                                    src={item.image}
                                    alt={item.title}
                                    style={{ height: '300px', objectFit: 'cover' }}
                                />
                                <Card.Body>
                                    <Card.Title style={{ fontSize: '1rem' }}>{item.title}</Card.Title>
                                    {item.badge && (
                                        <div
                                            className="badge bg-danger text-white"
                                            style={{ fontSize: '0.75rem' }}
                                        >
                                            {item.badge}
                                        </div>
                                    )}
                                    {/* <Button variant="warning" size="sm" className="mt-2 w-100"> */}
                                    <Button variant="warning" size="sm" className={Styles.carddBtn}
                                        onClick={() => handleAddToCart(item)}>
                                        Add to cart
                                    </Button>
                                    <Button variant="success" size="sm" className={Styles.buyBtn}
                                        onClick={() => window.open(item.url, "_blank")} // 👉 opens in new tab
                                    >
                                        {/* <Button variant="success" size="sm" className="mt-2 w-100"> */}
                                        Buy
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container></>
    )
}

export default BoysFashionAge2to6;